export default __webpack_public_path__ + "media/images/channelorg-f79a7a959936a1c9a6f087f771d2618a.png";